<!--  

visao por etapa
criar lista de etapas horizontal conforme filter-list


visao timeline
criar lista de meses horizontal conforme filter-list



1 - CRM-FILTRO
2 - CRM-FUNIL-FORM
3 - CRM-PAINEL-ETAPA
4 - CRM-NEGOCIO-FORM

- CRM-PESSOA-LIST
- CRM-ORGANIZACAO-LIST

-->



<script>

import BarList from '../components/bar-list'
import CrmFiltros from './crm-filtros'
import CrmFiltrosNegocio from './crm-filtros-negocio'
import CrmPainelEtapa from './crm-painel-etapa'
import CrmPainelTimeline from './crm-painel-timeline'
import CrmPainelList from './crm-painel-list'
import CrmPessoaForm from './crm-pessoa-form'
import CrmPessoaNovoForm from './crm-pessoa-novo-form'
import CrmOrgNovoForm from './crm-org-novo-form'
import CrmNegocioNovoForm from './crm-negocio-novo-form'
import CrmNegocioForm from './crm-negocio-form'
import CrmFunilForm from './crm-funil-form'
import CrmPublicForm from './crm-public-form'
import { apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import { getText } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,

            mounted: false,

            showEtapa: true,
            showTimeline: false,
            showLista: false,
            
            formNegocio: false,
            formNovoNegocio: false,
            codnegocio: null,

            showFormPessoa: false,
            showFormOrg: false,
            showPublicForm: false,

            formFunil: false,
            codfunil: null,

            moreActions: [  //botao mais acoes
                { action: 1, label: 'Incluir Funil' },
                { action: 2, label: 'Editar Funil Atual' }
            ],  

            selectedUsuario: null,
            selectedFunil: null,
            selectedFiltroNegocios: null,

            filtroMes: {            //objeto utilizado pelo filtro de mes
                startDate: null,
                endDate: null,
                codusuario: null,
            },

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permitenovo: true,
                // duplicados: true,
                codigo: null,
                label: 'Organização',
                icon: 'fa-university', 
                placeholder: 'Organização',
            },

            inputContato: {
                url: '/crm/find/pessoa?nome=',
                // permitenovo: true,
                duplicados: true,
                codigo: null,
                label: 'Contato',
                icon: 'fa-user', 
                placeholder: 'Contato',
            },

        }


    },

    components: {
        BarList, CrmOrgNovoForm, CrmPessoaNovoForm, CrmNegocioNovoForm, CrmNegocioForm, CrmPainelEtapa, CrmPainelTimeline, 
        CrmPainelList, CrmFiltros, CrmFiltrosNegocio, CrmFunilForm, CrmPublicForm
    },

    computed: {
        // pessoaList: function () {
        //     return this.$store.getters.getPessoaList
        // },

        usuarioList: function () {
            //lista de usuarios para selecao
            let options = []
            for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
                options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome })
            }
            return options
        },

        etapaList: function () {
            if (this.$store.getters.getConfigCrm.etapas)
              return this.$store.getters.getConfigCrm.etapas
            else
              return []
        },

        funilList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.funil
            else
                return []
        },

        showPainel: function () {
            return !this.formNegocio
        },

        startDate () {
            return this.filtroMes.startDate
        },

        codusuario () {
            return this.filtroMes.codusuario
        },

        administrador: function () {
            return SysVars.usuarioAdministrador
        },

    },

    watch: {

    },

    filters: {

    },

    methods: {
        closeFormNegocio (negocio) {
            this.formNegocio = false
            this.formNovoNegocio = false

            if (negocio && this.$refs.painelEtapa) {
                //ATUALIZA O PAINEL DE ETAPA
                this.$refs.painelEtapa.loadData()
            } else
            if (negocio && this.$refs.painelTimeline) {
                //ATUALIZA O PAINEL TIMELINE
                this.$refs.painelTimeline.loadData()
            } else
            if (negocio && this.$refs.painelLista) {
                //ATUALIZA O PAINEL LISTA
                this.$refs.painelLista.loadData()
            }
        },
    
        handleChangeUsuario (cod) {
            this.selectedUsuario = cod
        },

        handleChangeEquipe (cod) {
            this.selectedEquipe = cod
        },

        handleChangeFiltroNegocios (filtro) {
            /*
            evento acionado pelo crm-filtros-negocio
            */
            this.selectedFiltroNegocios = filtro
        },

        handleChangeFunil (cod) {
            let funil = this.funilList.filter((option) => {
                return option.codfunil == cod
            })
            funil[0].etapas = this.etapaList.filter((option) => {
                return option.codfunil == funil[0].codfunil
            })
            this.selectedFunil = funil[0]
        },






        handleVisaoEtapa () {
            this.showTimeline = false
            this.showEtapa = true
            this.showLista = false
        },

        handleVisaoLista () {
            this.showTimeline = false
            this.showEtapa = false
            this.showLista = true
        },

        handleVisaoTimeline () {
            this.showEtapa = false
            this.showTimeline = true
            this.showLista = false
        },

        handleMonthChange() {
            // console.log('handleMonthChange')
            // console.log(this.filter)
        },

        handleNovoNegocio () {
            this.formNovoNegocio = true
        },

        handleEditNegocio (cod) {
            this.codnegocio = cod
            this.$router.push('/crm/negocio/' + cod)
        },

        handleNovoPessoa () {
            this.showFormPessoa = true
        },

        handleAction (act) {
            if (act == 1) {
                this.handleNovoFunil()
            }
            if (act == 2) {
                this.handleEditarFunil()
            }
        },

        closeFormPessoa () {
            this.showFormPessoa = false
        },

        handleNovoOrg () {
            this.showFormOrg = true
        },

        closeFormOrg () {
            this.showFormOrg = false
        },

        handlePublicForm () {
            this.showPublicForm  = true
        },

        closePublicForm (negocio) {
            this.showPublicForm  = false
        },

        handleNovoFunil () {
            this.codfunil = null
            this.formFunil = true
        },

        handleEditarFunil () {
            this.codfunil = this.selectedFunil.codfunil
            this.formFunil = true
        },

        handleCloseFormFunil (cod) {
            console.log(cod)
            if (cod) {
              this.loadData(cod)
            }
            this.formFunil = false
        },

        async loadData (funil) {
            //CARREGA AS CONFIGURACOES DO CRM
            await this.$store.dispatch('loadConfigCrm', this)

            if (funil) {
              //SE UM NOVO FUNIL FOI CRIADO OU ALTERADO 
              this.handleChangeFunil(funil.codfunil)
            }
            else
            if (!this.selectedFunil) {
                this.handleChangeFunil(this.funilList[0].codfunil)
            }
            this.mounted = true
        }

    },

    created () {
        this.loadData()

    }

}

</script>

<template>
<div class="container-full-width">
    <div v-if="mounted && showPainel">
        <div class="default-container mb-3">
            <div class="row">
                <div class="col-auto">
                    <div class="btn-group">
                        <v-button title="Visão por etapas" :nb-btdef="showEtapa" icon="fa-th" @click="handleVisaoEtapa"></v-button>
                        <v-button title="Visão por timeline" :nb-btdef="showTimeline" icon="fa-calendar" @click="handleVisaoTimeline"></v-button>
                        <v-button title="Visão por lista" :nb-btdef="showLista" icon="fa-list" @click="handleVisaoLista"></v-button>
                    </div>
                </div>

                <!-- filtro de data para o painel timeline -->
                <div class="col-auto">
                    <input-month v-if="showTimeline" :p-month="filtroMes" :show-options="false" @monthChange="handleMonthChange"></input-month>
                </div>

                <!-- <div class="col-md-4 col-10">
                    <crm-filtros ref="filtro" :params="{ funil: true, usuario: true }" 
                        @changeUsuario="handleChangeUsuario" 
                        @changeFunil="handleChangeFunil">
                    </crm-filtros>
                </div> -->

                <div class="col-auto ml-auto text-righy">
                    <v-button v-if="administrador && moreActions.length > 0" :actions="moreActions" @click="handleAction"></v-button>
                    <v-button title="Incluir novo contato" icon="fa-user" @click="handleNovoPessoa"></v-button>
                    <v-button title="Incluir nova organização" icon="fa-university" @click="handleNovoOrg"></v-button>
                    <v-button title="Formulário Público" icon="fa-magic" @click="handlePublicForm"></v-button>
                    <v-button label="Novo Negócio" title="Incluir novo negócio" :nb-btdef="true" icon="fa-plus" @click="handleNovoNegocio"></v-button>
                </div>

                <div class="col-12 mt-2">
                    <crm-filtros-negocio :negocios="true"
                                @changeFiltro="handleChangeFiltroNegocios"
                                @changeUsuario="handleChangeUsuario" 
                                @changeFunil="handleChangeFunil"
                                @editfunil="handleEditarFunil" 
                                @novofunil="handleNovoFunil" 
                                ></crm-filtros-negocio>
                </div>
            </div>
        </div>

        <crm-painel-etapa ref="painelEtapa" v-if="showEtapa" :funil="selectedFunil" :usuario="selectedUsuario" :start-date="filtroMes.startDate" :filtro="selectedFiltroNegocios" @edit="handleEditNegocio"></crm-painel-etapa>
        <crm-painel-timeline ref="painelTimeline" v-if="showTimeline" :funil="selectedFunil" :usuario="selectedUsuario" :start-date="filtroMes.startDate" :filtro="selectedFiltroNegocios" @edit="handleEditNegocio"></crm-painel-timeline>
        <crm-painel-list ref="painelLista" v-if="showLista" :funil="selectedFunil" :usuario="selectedUsuario" :start-date="filtroMes.startDate" :filtro="selectedFiltroNegocios" @edit="handleEditNegocio"></crm-painel-list>
    </div>
    <crm-funil-form v-if="formFunil" :index="codfunil" @closeform="handleCloseFormFunil"></crm-funil-form>
    <crm-public-form v-if="showPublicForm" @closeform="closePublicForm"></crm-public-form>
    <crm-org-novo-form v-if="showFormOrg" @closeform="closeFormOrg"></crm-org-novo-form>
    <crm-pessoa-novo-form v-if="showFormPessoa" @closeform="closeFormPessoa"></crm-pessoa-novo-form>
    <crm-negocio-form v-if="formNegocio" :index="this.codnegocio" @closeform="closeFormNegocio"></crm-negocio-form>
    <crm-negocio-novo-form v-if="formNovoNegocio" :index="this.codnegocio" :funil="selectedFunil" @closeform="closeFormNegocio"></crm-negocio-novo-form>
</div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-painel-form.vue